/**
 * @desc 通过SupplierIdName获取供应商主体信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierInfo.getBySupplierIdName.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/getBySupplierIdName`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
